module.exports = "/_next/static/images/participation2-e05e52cdce044ae4bd63baf6307cc007.svg";